import { Button, Col, Container, Image, Row, Tab, Tabs } from "react-bootstrap";
import carrersImg from "../../../Assets/Images/Careers/Careers.png";
import {
  primaryColor,
  secondaryColor,
  textDarkColor,
  textLightColor,
} from "../../../Constants/Colors";
import { LuArrowUpRight } from "react-icons/lu";
import "./Careers.css";
import { brandLogo, brandName } from "../../../Constants/content";
import { GoArrowUpRight } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import carrersExploreImg from "../../../Assets/Images/Careers/carrerExplore.jpg";

const Careers = () => {
  const navigate = useNavigate();
  const radius = 60;

  const careersDescription = `At ${brandName}, we foster an environment of collaboration, creativity, and continuous growth. Join us to build impactful digital products and grow with a team that values your ideas.`;

  const carrers = [
    {
      eventKey: "design",
      title: "Design",
    },
    {
      eventKey: "development",
      title: "Development",
    },
    {
      eventKey: "marketing",
      title: "Marketing",
    },
    {
      eventKey: "support",
      title: "Support",
    },
    {
      eventKey: "others",
      title: "Others",
    },
  ];

  const carersData = [
    {
      eventKey: "design",
      jobName: "UI/UX Designer",
      type: "Full time",
      description:
        "Create engaging blogs, articles, and social posts. Stay current with trends.",
      link: "/careers/ui-ux-designer",
    },
    {
      eventKey: "development",
      title: "Development",
      jobName: "Software Developer",
      type: "Full time",
      description: "Build scalable, high-performing web apps.",
      link: "/careers/software-developer",
    },
    {
      eventKey: "marketing",
      title: "Marketing",
      jobName: "Digital Marketing Analyst",
      type: "Full time",
      description: "Run ad campaigns and report ROI performance.",
      link: "/careers/digital-marketing-analyst",
    },
    {
      eventKey: "support",
      title: "Support",
      jobName: "Customer Support Specialist",
      type: "Full time",
      description: "Assist customers with inquiries and provide solutions.",
      link: "/careers/customer-support-specialist",
    },
  ];

  const whyJoinUs = [
    {
      title: "Friendly Work Culture",
      description:
        "We foster a collaborative, respectful, and positive workspace that feels like a second home.",
    },
    {
      title: "Continuous Learning",
      description:
        "We invest in your growth through regular workshops, mentorship, and hands-on project experience.",
    },
    {
      title: "Recognition that Matters",
      description:
        "Your contributions won’t go unnoticed. We celebrate wins — big or small — and reward impact.",
    },
    {
      title: "Team Bonding & Fun",
      description:
        "From office celebrations to team outings and friendly games — we make workdays more fun.",
    },
  ];

  return (
    <>
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={6}
            className="m-auto d-flex flex-column justify-content-center"
          >
            <div
              style={{
                textAlign: "center",
              }}
            >
              <Button
                style={{
                  backgroundColor: "#009dff",
                  border: "none",
                  boxShadow: "0 4px 20px rgba(0, 157, 255, 0.3)",
                }}
                className="rounded-pill my-2 px-4"
              >
                Careers
              </Button>

              <h1
                className="my-3"
                style={{ color: "#009dff", fontWeight: "bold" }}
              >
                Build the Future With Us
              </h1>

              <p className="text-muted mb-4">{careersDescription}</p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Image src={carrersImg} fluid />
          </Col>
        </Row>

        <Row>
          <h1 className="my-5 text-center">
            Shape the <span style={{ color: primaryColor }}>Future</span> With{" "}
            <span style={{ color: primaryColor }}>Your Skills</span>{" "}
          </h1>

          <Tabs
            defaultActiveKey="design"
            id="fill-tab-example"
            className="mb-3"
          >
            {carrers.map((career, index) => (
              <Tab eventKey={career.eventKey} title={career.title} key={index}>
                {carersData &&
                carersData.filter((job) => job.eventKey === career.eventKey)
                  .length > 0 ? (
                  carersData
                    .filter((job) => job.eventKey === career.eventKey)
                    .map((job, jobIndex) => (
                      <Row
                        key={jobIndex}
                        style={{
                          border: `2px solid #819A91`,
                          borderRadius: "15px",
                          width: "80%",
                        }}
                        className="my-4 m-auto"
                      >
                        <Col xs={9} className="py-3 px-4">
                          <h6
                            style={{ color: primaryColor }}
                            className="fw-bold"
                          >
                            {job.jobName}
                          </h6>
                          <h5 className="fw-bold">Full time</h5>
                          <p>{job.description}</p>
                          <Link to={job.link} style={{ color: primaryColor }}>
                            Learn more <LuArrowUpRight className="fs-5" />
                          </Link>
                        </Col>
                        <Col className="d-flex align-items-center justify-content-center">
                          <Button
                            onClick={() => navigate(job.link)}
                            style={{
                              backgroundColor: secondaryColor,
                              color: textDarkColor,
                              border: "none",
                              boxShadow: "0 4px 20px rgba(0, 157, 255, 0.3)",
                            }}
                            className="rounded-pill my-2 px-4"
                          >
                            Apply Now <LuArrowUpRight className="fs-5" />
                          </Button>
                        </Col>
                      </Row>
                    ))
                ) : (
                  <Row className="text-center py-5">
                    <Col
                      xs={12}
                      md={10}
                      className="alert alert-warning m-auto"
                      role="alert"
                    >
                      <h5 className="alert-heading">No Positions Available</h5>
                      <p className="mb-0">
                        There are currently no open positions in this category.
                        Please check back later or explore other career
                        opportunities.
                      </p>
                    </Col>
                  </Row>
                )}
              </Tab>
            ))}
          </Tabs>
        </Row>

        <h1 style={{ color: primaryColor }} className="text-center">
          Why should you join us?
        </h1>
        <Row className="my-4">
          <Col xs={12} md={11} className="m-auto">
            <p className="text-justify">
              At {brandName}, every team member is seen, heard, and empowered.
              We believe in creating a workplace where your work matters, your
              ideas are valued, and your growth is a shared goal. Here, you're
              not just part of a team — you're part of something meaningful.
            </p>
          </Col>
        </Row>

        <Row className="d-flex justify-content-around">
          {whyJoinUs.map((item, index) => (
            <Col
              key={index}
              xs={11}
              md={4}
              style={{
                border: `3px solid ${primaryColor}`,
                borderRadius: "20px",
              }}
              className="px-3 py-5 mb-5 mx-lg-4 mx-0"
            >
              <h5 className="barTop position-relative mb-4">{item.title}</h5>
              <p className="text-justify mb-0">{item.description}</p>
            </Col>
          ))}
        </Row>

        <Row>
          <Col xs={12} md={10} className="m-auto mb-5">
            <div
              style={{
                padding: "2px",
                borderRadius: "20px",
                background: `linear-gradient(to right, ${secondaryColor}, ${primaryColor})`,
              }}
            >
              <Row
                className="align-items-center p-2 p-md-1 m-auto justify-content-center py-3"
                style={{
                  backgroundColor: "#c6e0f7",
                  borderRadius: "18px",
                }}
              >
                <Col
                  xs={3}
                  className="d-flex justify-content-center align-items-center"
                >
                  <Image
                    src={brandLogo}
                    style={{ width: "120px", height: "80px" }}
                  />
                </Col>
                <Col md={6} className="text-start py-3">
                  <h5>
                    Didn’t find the role you’re looking for? Let’s still
                    connect.
                  </h5>
                  <p className="p-0 m-0 mt-lg-3 mt-3">
                    Send your resume + portfolio to hr@idealcorp.in
                  </p>
                  <p className="p-0 m-0 mt-lg-3 mt-3">
                    Subject: [Your Role] – [Your Name]
                  </p>
                  <p className="p-0 m-0 mt-lg-3 mt-3">
                    Or Hit &nbsp;&nbsp;
                    <a
                      href="/test"
                      style={{ color: textDarkColor }}
                      className=""
                    >
                      Apply Now <LuArrowUpRight className="fs-5" />
                    </a>
                  </p>
                </Col>
                <Col md={3} className="text-end mt-3 mt-md-0">
                  <div
                    style={{
                      position: "relative",
                      width: radius * 2 + 40,
                      height: radius * 2 + 40,
                      margin: "auto",
                    }}
                  >
                    {/* Static Center Icon */}
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                      }}
                    >
                      <GoArrowUpRight
                        size={38}
                        color={textDarkColor}
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/careers")}
                      />
                    </div>

                    {/* Rotating SVG Circle with Text */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        animation: "spin 10s linear infinite",
                        zIndex: 1,
                      }}
                    >
                      <svg width="100%" height="100%" viewBox="0 0 250 250">
                        <defs>
                          <path
                            id="circlePath"
                            d={`
                                     M 125,125
                                     m -${radius},0
                                     a ${radius},${radius} 0 1,1 ${radius * 2},0
                                     a ${radius},${radius} 0 1,1 -${
                              radius * 2
                            },0
                                   `}
                          />
                        </defs>
                        <text
                          fill={textDarkColor}
                          fontSize="20"
                          fontFamily="sans-serif"
                        >
                          <textPath href="#circlePath" startOffset="0%">
                            Get in touch • Hire us • Contact us • Connect with
                            us •
                          </textPath>
                        </text>
                      </svg>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        <Row
          className="d-flex justify-content-center align-items-center careers-background mb-5"
          style={{
            backgroundImage: `url(${carrersExploreImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Col
            xs={12}
            md={8}
            className="text-center d-flex flex-column align-items-center"
          >
            <h1 style={{ color: textLightColor }}>
              The future is built by people who care. Let’s design it together.
            </h1>
            <Button
              style={{
                backgroundColor: secondaryColor,
                color: textDarkColor,
                border: "none",
                boxShadow: "0 4px 20px rgba(0, 157, 255, 0.3)",
              }}
              className="rounded-pill my-2 px-4"
            >
              Apply Now <LuArrowUpRight className="fs-5" />
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Careers;
